import { v7 as uuidv7 } from "uuid";
import { z } from "zod";
import { itemSchema } from "./item";
import { officeSchema } from "./office";

export const projectSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  itemId: itemSchema.shape.id,
  fiscalYear: z.string().nullish(),
  workTitle: z.string().nullish(),
  workDetail: z.string().nullish(),
  drawingType: z.string().nullish(),
  workYearMonth: z.string().nullish(),
  createdAt: z.coerce.date().default(new Date()),
  updatedAt: z.coerce.date().default(new Date()),
});

export const getProjectSchema = projectSchema.extend({
  parentId: z.string().uuid().nullish(),
  officeId: officeSchema.shape.id,
  itemType: z.enum(["folder", "project"]),
  path: z.string(),
});

export const newProjectInputSchema = projectSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export const editProjectInputSchema = projectSchema.pick({
  name: true,
  fiscalYear: true,
  workTitle: true,
  workDetail: true,
  drawingType: true,
  workYearMonth: true,
});

export type Project = z.infer<typeof projectSchema>;
export type ProjectInput = z.input<typeof projectSchema>;
export type NewProjectInput = z.input<typeof newProjectInputSchema>;
export type EditProjectInput = z.input<typeof editProjectInputSchema>;

export const createProject = (input: NewProjectInput): Project => {
  return newProject({
    ...input,
    id: uuidv7(),
  });
};

export const newProject = (input: ProjectInput): Project => projectSchema.parse(input);
